
/* prettier-ignore */ /**
 * typekit-cache.js
 * https://github.com/morris/typekit-cache/blob/master/typekit-cache.js
 */ (function(// Constants
document1, style, innerHTML, getElementsByTagName, // Config
storage, key, pattern, delay, // Vars
temp, next, i, css) {
    // If CSS is in cache, append it to <head> in a <style> tag.
    if (storage[key]) {
        temp = document1.createElement(style);
        temp[innerHTML] = storage[key];
        document1[getElementsByTagName]('head')[0].appendChild(temp);
        document1.documentElement.className += ' wf-cached';
    }
    // Find and cache the Typekit CSS.
    (function cache() {
        // Find matching CSS.
        temp = document1[getElementsByTagName](style);
        next = '';
        for(i = 0; i < temp.length; i++){
            css = temp[i][innerHTML];
            if (css && css.match(pattern)) next += css;
        }
        // If there's matching CSS, cache it.
        // Prefix cached CSS so it does not match the pattern.
        if (next) storage[key] = '/**/' + next;
        // Retry using exponential backoff.
        setTimeout(cache, delay += delay);
    })();
})(// Constants
document, 'style', 'innerHTML', 'getElementsByTagName', // Config
localStorage, 'tk', /^@font|^\.tk-/, 100);
/* prettier-ignore */ (function(d) {
    var config = {
        kitId: 'ysi4rlt',
        scriptTimeout: 3000,
        async: true
    }, h = d.documentElement, t = setTimeout(function() {
        h.className = h.className.replace(/\bwf-loading\b/g, '') + ' wf-inactive';
    }, config.scriptTimeout), tk = d.createElement('script'), f = false, s = d.getElementsByTagName('script')[0], a;
    h.className += ' wf-loading';
    tk.src = 'https://use.typekit.net/' + config.kitId + '.js';
    tk.async = true;
    tk.onload = tk.onreadystatechange = function() {
        a = this.readyState;
        if (f || a && a != 'complete' && a != 'loaded') return;
        f = true;
        clearTimeout(t);
        try {
            /* eslint no-undef: 0 */ Typekit.load(config);
        /* eslint no-empty: 0 */ } catch (e) {}
    };
    s.parentNode.insertBefore(tk, s);
})(document);


const $d393353ec319e16c$var$OPENINGS = "\uFF08\uFF3B\uFF5B\u3014\u3008\u300A\u300C\u300E\u3010\u3018\u3016\u201C\u2018";
const $d393353ec319e16c$var$CLOSINGS = "\uFF09\uFF3D\uFF5D\u3015\u3009\u300B\u300D\u300F\u3011\u3019\u3017\u201D\u2019";
const $d393353ec319e16c$var$MIDDLE_DOTS = "\u30FB\uFF1A\uFF1B";
const $d393353ec319e16c$var$COMMAS = "\u3001\uFF0C";
const $d393353ec319e16c$var$PERIODS = "\u3002\uFF0E";
const $d393353ec319e16c$export$641194ef37ada0de = /[\p{scx=Latin}0-9⁰¹²³⁴-⁾₀-₎¢¤$€£¥+−×÷=≠><≥≤±≈~¬∅∞∫∏∑√∂%‰@&.,:;!¡?¿'"‘’“”\-(){}[\]|/\\^_`*#\s]+/gu;
const $d393353ec319e16c$export$4cb558b7b9022047 = new RegExp($d393353ec319e16c$export$641194ef37ada0de.source, "u");
const $d393353ec319e16c$export$2ad5385eaeec24f9 = new RegExp(`[${$d393353ec319e16c$var$OPENINGS}]`);
const $d393353ec319e16c$export$1ab58bccf186f593 = new RegExp(`[${$d393353ec319e16c$var$CLOSINGS}]`);
const $d393353ec319e16c$export$288a0444d03fbf01 = new RegExp(`[${$d393353ec319e16c$var$MIDDLE_DOTS}]`);
const $d393353ec319e16c$export$63cbbb231969d700 = new RegExp(`[${$d393353ec319e16c$var$COMMAS}]`);
const $d393353ec319e16c$export$2bd2dd7309ab667a = new RegExp(`[${$d393353ec319e16c$var$PERIODS}]`);
const $d393353ec319e16c$export$79f2b8e7ea0abe9 = new RegExp(`[${$d393353ec319e16c$var$CLOSINGS}${$d393353ec319e16c$var$COMMAS}${$d393353ec319e16c$var$PERIODS}]`);
const $d393353ec319e16c$export$63ebc33299cdae8f = new RegExp(`[\\p{scx=Hiragana}\\p{scx=Katakana}\uFF66-\uFF9F\\p{scx=Han}${$d393353ec319e16c$var$OPENINGS}${$d393353ec319e16c$var$CLOSINGS}${$d393353ec319e16c$var$MIDDLE_DOTS}${$d393353ec319e16c$var$COMMAS}${$d393353ec319e16c$var$PERIODS}]`, "u");
const $d393353ec319e16c$export$96e1aeec61700254 = new RegExp(`[,.${$d393353ec319e16c$var$OPENINGS}${$d393353ec319e16c$var$CLOSINGS}${$d393353ec319e16c$var$MIDDLE_DOTS}${$d393353ec319e16c$var$COMMAS}${$d393353ec319e16c$var$PERIODS}]`);
const $d393353ec319e16c$export$198c1e54754651b7 = /[—‥…＿─-╿]+/g;
const $d393353ec319e16c$export$b6f55e4fcf94bf41 = new RegExp($d393353ec319e16c$export$198c1e54754651b7.source);
const $d393353ec319e16c$export$e847ddd80e1fcdc0 = /\s/;
const $d393353ec319e16c$export$e53e334ee9964e70 = /^\s*$/;
const $d393353ec319e16c$export$986efeeb4f9b2519 = /[\p{sc=Latin}0-9]/u;
const $d393353ec319e16c$export$900e02bd27a6a3dd = /[\p{sc=Hiragana}\p{sc=Katakana}\p{sc=Han}]/u;


const $b78c054bfb7eb7dd$var$PROTECTED_BLOCK_TOKEN_PREFIX = "__TYPESETTING_PROTECTED_BLOCK__";
const $b78c054bfb7eb7dd$var$PROTECTED_GENERATED_TOKEN_PREFIX = "__TYPESETTING_PROTECTED_GENERATED__";
const $b78c054bfb7eb7dd$var$htmlTokenRegex = /<[^>]+>|[^<]+/g;
const $b78c054bfb7eb7dd$var$protectedBlockRegex = /<(script|style|textarea|code|pre|kbd|samp)\b[^>]*>[\s\S]*?<\/\1>/gi;
const $b78c054bfb7eb7dd$var$VOID_TAGS = /* @__PURE__ */ new Set([
    "area",
    "base",
    "br",
    "col",
    "embed",
    "hr",
    "img",
    "input",
    "link",
    "meta",
    "param",
    "source",
    "track",
    "wbr"
]);
const $b78c054bfb7eb7dd$var$MANAGED_CLASS_NAMES = /* @__PURE__ */ new Set([
    "typesetting-wrapper",
    "typesetting-word-break",
    "typesetting-latin",
    "typesetting-no-breaks",
    "typesetting-thin-space",
    "typesetting-kerning"
]);
const $b78c054bfb7eb7dd$var$MANAGED_CLASS_PREFIXES = [
    "typesetting-char-"
];
class $b78c054bfb7eb7dd$var$HTMLProcessor {
    /**
   * HTMLProcessor を初期化します。
   *
   * @param transformFunctions - テキストトークンごとに適用する変換関数の配列。
   * @param options - 各変換関数に渡す組版オプション。
   */ constructor(transformFunctions, options){
        this.transformFunctions = transformFunctions;
        this.options = options;
    }
    /**
   * 与えられたHTML文字列に対して、各変換関数を順次適用し、変換されたHTML文字列を返します。
   * 文字列ベースで高速に処理しつつ、保護対象のブロックはそのまま保持します。
   *
   * @param srcHtml - 変換を適用する元のHTML文字列。
   * @return 変換後のHTML文字列。
   */ processHtmlWithFunctions(srcHtml) {
        if (srcHtml === "") return srcHtml;
        const { html: htmlWithoutProtectedBlocks, protectedBlocks: protectedBlocks } = this.extractProtectedBlocks(srcHtml);
        const { html: html, protectedBlocks: protectedGeneratedBlocks } = this.extractManagedGeneratedBlocks(htmlWithoutProtectedBlocks);
        let processedHtml = html;
        for (const transformFunction of this.transformFunctions)processedHtml = this.processHtml(processedHtml, transformFunction);
        const restoredGeneratedHtml = this.restoreProtectedBlocks(processedHtml, protectedGeneratedBlocks, $b78c054bfb7eb7dd$var$PROTECTED_GENERATED_TOKEN_PREFIX);
        return this.restoreProtectedBlocks(restoredGeneratedHtml, protectedBlocks, $b78c054bfb7eb7dd$var$PROTECTED_BLOCK_TOKEN_PREFIX);
    }
    /**
   * HTML文字列を「タグ」と「テキスト」に分割し、テキスト部分に対して変換関数を適用します。
   *
   * @param html - 解析および変換するHTML文字列。
   * @param transformFunction - テキスト部分に適用する変換関数。
   * @return 変換後のHTML文字列。
   */ processHtml(html, transformFunction) {
        if (html === "") return html;
        const tokens = html.match($b78c054bfb7eb7dd$var$htmlTokenRegex) ?? [];
        const nextTexts = [];
        let nextText = "";
        for(let i = tokens.length - 1; i >= 0; i--){
            if (tokens[i][0] === "<") continue;
            nextTexts[i] = nextText;
            nextText = tokens[i];
        }
        for(let i = 0; i < tokens.length; i++){
            if (tokens[i][0] === "<" || (0, $d393353ec319e16c$export$e53e334ee9964e70).test(tokens[i])) continue;
            tokens[i] = transformFunction(tokens[i], nextTexts[i], this.options);
        }
        return tokens.join("");
    }
    /**
   * 除外対象のブロック要素を一時的なプレースホルダに置き換えます。
   * これにより、文字列ベースのトークン処理中に script/style などの中身が
   * 組版対象として誤って書き換えられることを防ぎます。
   *
   * @param html - 保護対象のブロックを含むHTML文字列。
   * @return プレースホルダ化後のHTMLと、退避したブロックの配列。
   */ extractProtectedBlocks(html) {
        const protectedBlocks = [];
        const extractedHtml = html.replace($b78c054bfb7eb7dd$var$protectedBlockRegex, (block)=>{
            const token = `<!--${$b78c054bfb7eb7dd$var$PROTECTED_BLOCK_TOKEN_PREFIX}${protectedBlocks.length}-->`;
            protectedBlocks.push(block);
            return token;
        });
        return {
            html: extractedHtml,
            protectedBlocks: protectedBlocks
        };
    }
    /**
   * 既に組版済みの span 要素をプレースホルダに置き換えます。
   * ここで保護するのは入力HTMLに元から存在していた要素だけで、
   * 今回の render() 中に生成される wrapper や latin span は後続の変換対象に残します。
   *
   * @param html - 既生成の span 要素を含むHTML文字列。
   * @return プレースホルダ化後のHTMLと、退避した要素の配列。
   */ extractManagedGeneratedBlocks(html) {
        const protectedBlocks = [];
        const outputTokens = [];
        const protectedTokens = [];
        const protectedTagStack = [];
        for (const token of html.match($b78c054bfb7eb7dd$var$htmlTokenRegex) ?? []){
            const tagInfo = token[0] === "<" ? this.getTagInfo(token) : null;
            const isInsideProtectedBlock = protectedTagStack.length > 0;
            if (!isInsideProtectedBlock && tagInfo && !tagInfo.isClosing && !tagInfo.isSelfClosing && this.isManagedGeneratedTag(tagInfo)) {
                protectedTagStack.push(tagInfo.tagName);
                protectedTokens.push(token);
                continue;
            }
            if (!isInsideProtectedBlock) {
                outputTokens.push(token);
                continue;
            }
            protectedTokens.push(token);
            if (!tagInfo) continue;
            if (tagInfo.isClosing) {
                if (protectedTagStack[protectedTagStack.length - 1] === tagInfo.tagName) protectedTagStack.pop();
            } else if (!tagInfo.isSelfClosing && !$b78c054bfb7eb7dd$var$VOID_TAGS.has(tagInfo.tagName)) protectedTagStack.push(tagInfo.tagName);
            if (protectedTagStack.length === 0) {
                const placeholder = `<!--${$b78c054bfb7eb7dd$var$PROTECTED_GENERATED_TOKEN_PREFIX}${protectedBlocks.length}-->`;
                protectedBlocks.push(protectedTokens.join(""));
                outputTokens.push(placeholder);
                protectedTokens.length = 0;
            }
        }
        return {
            html: outputTokens.join(""),
            protectedBlocks: protectedBlocks
        };
    }
    /**
   * extractProtectedBlocks で退避したブロック要素を、元の位置へ復元します。
   *
   * @param html - プレースホルダを含むHTML文字列。
   * @param protectedBlocks - 退避していたブロック要素の配列。
   * @param tokenPrefix - extract 側で使用したプレースホルダの接頭辞。
   * @return プレースホルダを元のブロック要素に戻したHTML文字列。
   */ restoreProtectedBlocks(html, protectedBlocks, tokenPrefix) {
        return protectedBlocks.reduce((restoredHtml, block, index)=>restoredHtml.replace(`<!--${tokenPrefix}${index}-->`, ()=>block), html);
    }
    /**
   * タグ文字列から、タグ名とクラス名などの最小限の情報を抽出します。
   * コメントや doctype のような通常タグでないものは null を返します。
   *
   * @param tag - htmlTokenRegex で切り出したタグ文字列。
   * @return 抽出したタグ情報。通常タグでなければ null。
   */ getTagInfo(tag) {
        const closingMatch = tag.match(/^<\s*\/\s*([a-zA-Z][\w:-]*)\b/);
        if (closingMatch) return {
            tagName: closingMatch[1].toLowerCase(),
            isClosing: true,
            isSelfClosing: false,
            classNames: []
        };
        const openingMatch = tag.match(/^<\s*([a-zA-Z][\w:-]*)\b/);
        if (!openingMatch) return null;
        const classMatch = tag.match(/\bclass\s*=\s*(["'])(.*?)\1/i);
        const classNames = classMatch ? classMatch[2].split(/\s+/).filter(Boolean) : [];
        return {
            tagName: openingMatch[1].toLowerCase(),
            isClosing: false,
            isSelfClosing: /\/\s*>$/.test(tag),
            classNames: classNames
        };
    }
    /**
   * このライブラリが生成した要素として扱うべきタグかを判定します。
   * `.typesetting-*` を一括判定せず、実際に出力で使用しているクラスだけを対象にします。
   *
   * @param tagInfo - 判定対象のタグ情報。
   * @return ライブラリ生成要素なら true、そうでなければ false。
   */ isManagedGeneratedTag(tagInfo) {
        if (tagInfo.tagName !== "span") return false;
        return tagInfo.classNames.some((className)=>{
            return $b78c054bfb7eb7dd$var$MANAGED_CLASS_NAMES.has(className) || $b78c054bfb7eb7dd$var$MANAGED_CLASS_PREFIXES.some((prefix)=>className.startsWith(prefix));
        });
    }
}
var $b78c054bfb7eb7dd$export$2e2bcd8739ae039 = $b78c054bfb7eb7dd$var$HTMLProcessor;



const $cd0af1f91fa0e3d5$var$thinSpaceRules = [
    [
        $d393353ec319e16c$export$2ad5385eaeec24f9,
        true,
        false
    ],
    [
        $d393353ec319e16c$export$79f2b8e7ea0abe9,
        false,
        true
    ],
    [
        $d393353ec319e16c$export$288a0444d03fbf01,
        true,
        true
    ]
];
const $cd0af1f91fa0e3d5$export$85bd18d34f99c221 = {
    /**
   * セグメントが分離禁則文字で構成されているかどうかを判定します。
   * @param segment - 判定するテキストセグメント
   * @return 分離禁則文字で構成されている場合はtrue、そうでない場合はfalse
   */ shouldNotBreak: (segment)=>{
        return $d393353ec319e16c$export$b6f55e4fcf94bf41.test(segment);
    },
    /**
   * 2つのセグメント間に四分アキを追加すべきかを判断します。
   * @param current - 現在のセグメント
   * @param next - 次のセグメント
   * @return 四分アキを追加すべきかどうか
   */ shouldAddThinSpace: (current, next)=>{
        for (const [regex, hasSpaceBefore, hasSpaceAfter] of $cd0af1f91fa0e3d5$var$thinSpaceRules){
            if (hasSpaceBefore && regex.test(next) && !regex.test(current)) return true;
            if (hasSpaceAfter && regex.test(current) && !regex.test(next)) return true;
        }
        return false;
    },
    /**
   * セグメントの少なくとも一方に約物が含まれているかどうかを判定します。
   * @param {string} current - 現在のセグメント
   * @param {string} next - 次のセグメント
   * @return {boolean} 約物が含まれている場合はtrue、そうでない場合はfalse
   */ includesPunctuation: (current, next)=>{
        return $d393353ec319e16c$export$96e1aeec61700254.test(current) || $d393353ec319e16c$export$96e1aeec61700254.test(next);
    }
};
const $cd0af1f91fa0e3d5$export$af1d3c3d58202762 = {
    /**
   * セグメントがラテン文字で構成されているかどうかを判定します。
   * @param segment - 判定するテキストセグメント
   * @return ラテン文字で構成されている場合はtrue、そうでない場合はfalse
   */ isLatin: (segment)=>{
        return $d393353ec319e16c$export$4cb558b7b9022047.test(segment);
    },
    /**
   * セグメントが日本語文字で構成されているかどうかを判定します。
   * @param segment - 判定するテキストセグメント
   * @return 日本語文字で構成されている場合はtrue、そうでない場合はfalse
   */ isJapanese: (segment)=>{
        return $d393353ec319e16c$export$63ebc33299cdae8f.test(segment);
    },
    /**
   * 現在のセグメントと次のセグメントの言語が異なるかどうかを判定します。
   * この関数は、一方が日本語で他方が非日本語の場合にtrueを返します。
   * @param current - 現在のテキストセグメント
   * @param next - 次のテキストセグメント
   * @return 両セグメント間で言語が異なる場合にtrueを返す
   */ hasLanguageTransition: (current, next)=>{
        return $cd0af1f91fa0e3d5$export$af1d3c3d58202762.isJapanese(current) !== $cd0af1f91fa0e3d5$export$af1d3c3d58202762.isJapanese(next);
    },
    /**
   * 2つのセグメント間に四分アキを追加すべきかを判断します。
   * @param current - 現在のセグメント
   * @param next - 次のセグメント
   * @return 四分アキを追加すべきかどうか
   */ shouldAddThinSpace: (current, next)=>{
        return $cd0af1f91fa0e3d5$export$af1d3c3d58202762.hasLanguageTransition(current, next);
    },
    /**
   * UAX #14 が拾わない「ラテン・数字」と「CJK 文字／全角約物」の境界で
   * 改行を許容するかを判定します。日本語組版の慣習に合わせて、
   * 開き括弧の前・閉じ括弧や句読点の後では英数との境界で改行可能にします。
   *
   * 例: `e × 「` は true、`「 × h` は false（OP の後の禁則を尊重）。
   *
   * @param current - 現在の境界文字（1 文字）
   * @param next - 次の境界文字（1 文字）
   * @return 追加で改行可能とみなす場合は true
   */ canBreakAcrossScripts: (current, next)=>{
        if (!current || !next) return false;
        if ($d393353ec319e16c$export$986efeeb4f9b2519.test(current)) return $d393353ec319e16c$export$900e02bd27a6a3dd.test(next) || $d393353ec319e16c$export$2ad5385eaeec24f9.test(next);
        return ($d393353ec319e16c$export$900e02bd27a6a3dd.test(current) || $d393353ec319e16c$export$79f2b8e7ea0abe9.test(current)) && $d393353ec319e16c$export$986efeeb4f9b2519.test(next);
    }
};


const $fb3887f4f09ea4cb$var$prefix = "typesetting";
const $fb3887f4f09ea4cb$var$safeSpacingValue = /^[a-zA-Z0-9 .%()+*,/_-]+$/;
const $fb3887f4f09ea4cb$export$11e646d802d120fb = (value)=>{
    if (typeof value !== "string") return "0.2em";
    const trimmed = value.trim();
    return trimmed && $fb3887f4f09ea4cb$var$safeSpacingValue.test(trimmed) && !trimmed.includes("/*") && !trimmed.includes("*/") ? trimmed : "0.2em";
};
const $fb3887f4f09ea4cb$var$escapeAttribute = (value)=>value.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
const $fb3887f4f09ea4cb$export$4e02d859637d5c44 = ()=>{
    return "<wbr>";
};
const $fb3887f4f09ea4cb$export$9d9a4a3f615f382b = (thinSpaceWidth, breakable)=>{
    const content = "";
    const className = `${$fb3887f4f09ea4cb$var$prefix}-thin-space`;
    return $fb3887f4f09ea4cb$var$createSpacer(content, className, $fb3887f4f09ea4cb$export$11e646d802d120fb(thinSpaceWidth), breakable);
};
const $fb3887f4f09ea4cb$export$cee714c7a7ce6b85 = (kerningValue, breakable)=>{
    if (kerningValue === 0) return "";
    const content = "";
    const className = `${$fb3887f4f09ea4cb$var$prefix}-kerning`;
    if (kerningValue < 0) {
        const emValue = kerningValue / 1e3 / 2 + "em";
        const style = `margin: ${emValue};`;
        return $fb3887f4f09ea4cb$var$createStyledSpan(content, className, style);
    } else {
        const emValue = kerningValue / 1e3 + "em";
        return $fb3887f4f09ea4cb$var$createSpacer(content, className, emValue, breakable);
    }
};
const $fb3887f4f09ea4cb$export$6d506fabf9b15659 = (text, useWordBreak)=>{
    const wrapperName = `${$fb3887f4f09ea4cb$var$prefix}-wrapper`;
    const wordBreakName = `${$fb3887f4f09ea4cb$var$prefix}-word-break`;
    const className = useWordBreak ? `${wrapperName} ${wordBreakName}` : wrapperName;
    return $fb3887f4f09ea4cb$var$createStyledSpan(text, className);
};
const $fb3887f4f09ea4cb$export$6ef6634d3484b92e = (segment)=>{
    const className = `${$fb3887f4f09ea4cb$var$prefix}-latin`;
    return $fb3887f4f09ea4cb$var$createStyledSpan(segment, className);
};
const $fb3887f4f09ea4cb$export$b9f38fbcc8ce2b6c = (segment)=>{
    const className = `${$fb3887f4f09ea4cb$var$prefix}-no-breaks`;
    return $fb3887f4f09ea4cb$var$createStyledSpan(segment, className);
};
const $fb3887f4f09ea4cb$var$createStyledSpan = (content, className, style = "", attr = "")=>{
    const styleAttr = style ? ` style="${$fb3887f4f09ea4cb$var$escapeAttribute(style)}"` : "";
    return `<span class="${className}"${styleAttr}${attr}>${content}</span>`;
};
const $fb3887f4f09ea4cb$var$createSpacer = (content, className, value, breakable)=>{
    const style = `letter-spacing: ${value};`;
    const data = ` data-content="${breakable ? " " : "&nbsp;"}"`;
    return $fb3887f4f09ea4cb$var$createStyledSpan(content, className, style, data);
};



const $9bdb35da3b2f257a$export$b60e33c184aa70d2 = "15.0.0";
const $9bdb35da3b2f257a$export$2b94a4504870571c = "EjAbUbRcTbEsYb6b3b<b9b:b<b3b0b2b<b9b8b@b8b7b;k8c<d6b<bb0b9b2b<bd0bAb1b<bEgVbEba4b0b:b9d<f3b<bAb<c:b9b<cBb<g3b<d0b<uaBb<dBb<sBb<bgEdb4bEm4hEn<o8b<kaEh<jv8bAb<e9b<bEbtAbEb<bEc<bEc6bEb<i=bb<e=e<w:d8c<cEl6bEb6d<brEv;k:b;c<dEb<dv6b<bEh<cEg<cEc<bEe<c;k<xEb<beEbb<dnEl<p;k<bhEj<e8b6b<dEb9c<wEe<bEj<bEd<bEf<brEd<ciEi<bqEy<bEbh<ccEd<bEs<bEh<kEcAc;k<rEd<ceEb<bEh<cEc<cEd<jEb<kEc<c;k<c:c<f:b<b9b<cEb<cEd<ceEb<bEf<eEc<cEd<dEb<u;kEc<dEb<lEd<ceEb<bEi<bEd<bEd<uEc<c;k<b9b<iEg<bEd<ceEb<bEh<cEc<cEd<hEd<kEc<c;k<sEb<chEf<dEd<bEe<jEb<o;k<j9b<gEf<cdEb<bEh<bEd<bEe<hEc<lEc<c;k<hBb<jEdBb<cdEb<bEh<bEd<bEe<hEc<lEc<c;k<dEb<mEe<cdEc<bEh<bEd<bEe<jEb<kEc<c;k<j:b<hEd<csEb<eEg<bEb<bEi<g;k<cEc<cx9b<q;kAc<em;k<bnBe<bBc4bBcAb4b6f4b<b6b<dEc<g;k<kAbEb<bEb<bEb0b1b0b1bEc<bxEoAbEfAbEc<fEl<bEbk<bAc<gEb<jBcAbBb<f4c<dx;kAc<cq;k<dyIdsJcuKdk<nlEd<bAb<gcAb<ypAb<ba0b1b<daAd<bkEe<bcEdAc<bbEc<beEc<dsAc5b<bAb<bAb9b<e;k<y6cAcBb<b6c<bEd4bEb;k<edEc<biEb<eoEm<eEm<i6c;k<ey;k<cjEf<dvEb;k<g;k<wEbf<bxEf<bvEr<l;kAc<bAe<kEj<jAc<bEd<beEn<c;k<bsEo<bwEu<dAf;k<g;k<bkAc<dcEd<bEv<eEb<gEb<cEd<hqEn4bEbu4bEd<tpBb<cAh4bAdDbEbObEcAb4bAcCb<d3c0b3d0b3b<e?dAbRcEf4b:i<b3c<b5c<g8b0b1b5d<mAb:bAe<bAdFb<fEk<n0b1b<o0b1b<r9h:b9o:b9e:b9c:b9b:b9pEbh<s:b<f:b<m9b<jr9c<il?b<y0b1b0b1b<o>c<n0b1b<hp>e<ue>e<q>c<c>b<b>dMb>c<z>d<bs>b<w>b<cj>m<e>b<b>d<b>c<d>c<c>b<c>d<i>b<g>f<b>cMb>b<c>i<d>cMe<cz3g<b6c>b<d0b1b0b1b0b1b0b1b0b1b0b1b0b1b<db0b1b<bf0b1b0b1b0b1b0b1b0b1b<pn0b1b0b1b0b1b0b1b0b1b0b1b0b1b0b1b0b1b0b1b0b1b<cl0b1b0b1b<bg0b1b<bczEd<h6bAd<b6bAb<eiAb<oEb<dsEbg3oAi<bAb0bAb<c3c<c3c0b1b0b1b0b1b0b1bAe6b<bAc<bAc<fCcAd<bAc0bAi<bAb<bAc<d6c0b1b0b1b0b1b0b1bAb<bi>ba<b>dl<m>ig<ba>m<eAb1c>c5b>c0b1b0b1b0b1b0b1b0b1b>c0b1b0b1b0b1b0b1b5b0b1c>kEg>fEb>f5c>d<b5b>b5b>b5b>b5b>b5b>z5b>bf5b>b5b>b5b>g5b>g5c<cEc5e>b5c>b5b>b5b>b5b>b5b>z5b>bf5b>b5b>b5b>g5b>g5c>e5e>b<f>br<b>dq<b>dg<m5q>bf<b>bo<i>kke<cm>bfcf5b>brz<d>cd<cdAc<kjAb6bAb<q;k<crEe<bEk<bgEc<dcEc<bAf<kgEb<dEb<eEb<xEf<eEb<l:b<chBc6c<iEc<byEs<iAc;k<gEs<kBb<cEb;k<bcEiAc<xEn<mIbd<dEe<bvEo<gAd<g;k<w;k<bvEo<mEb<iEc<c;k<dAd<fjEfAc<dEc<jcEiAbEc<c;k<gGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbbGbHbb<mJx<eKbx<mnc>ts<bd=bEb=k<b=n<b=f<b=b<b=c<b=c<b=k<ta1b0b<hg:b<dEq8b1c8c6c0b1b?b<gEq>f0b1b0b1b0b1b0b1b0b1b0b1b0b1b0b1b>c0b1b>h1b>b1b<b5c6c>b0b1b0b1b0b1b>i<b>b9b:b>b<frFb<b6b>c9b:b>c0b1b>c1b>b1b>l5c>d6b>bb0b>b1b>bd0b>b1b>b0b1c0b1c5b>b5k>bt5c>bf<d>g<c>g<c>g<c>d<d:b9b>d9c<sEdPb<jzAd<jqEb<isEb<ftEf<bkAb<bwAb<hz;k<bkfAb<hrAb<irEd<bEc<fEe<boEd<eEb<qAi<flEc<jAg?b<coAh<sqEe<i;k<ofEcAb<dbEd<csEl<bxEe<esEd<cbEpAc<bd;kEb<cEc<kEe<btEl<dAeEb<bt;k<gEd<bkEo<b;kAe<bEc<bsEb<bBb<kEd<bwEo<eAc<bAbEe<bEc;k<bBb<bAd<cyEmAc<bAc<bEb<cEb<dzAb<cbEm<f;k<gEe<cdEc<bEh<cEc<cEd<jEb<kEc<cEh<dEf<hkEs<eAe<b;kAc<cEb<ddEu<m;k<ifEh<cEjBbAc6c<dAp<eEc<deErAc<n;k<gBn<ckEn<i;k<dy;k<cAd<jdEp<gj;k<csEg<bEc<cEe<bEb<bEcAd<j;k<epEh<cEh<bBb<bEb<bcEk<boEh<bEeBb<bAeBb<bEb<jEl<buEqAd<bBdAc<dpBk<lhEi<bEi<bAf<k;k<wBb6b<bgEw<bEo<esEg<dEb<bEc<bEh<bEb<i;k<bwEf<bEc<bEf<i;k<mrEe<jEc<bEb<bwEh<dEfAc>l;k<fb:e<beAb<brsAf<fgt0d1d<bk1b<d0b1b0b1b<jf0b1c<gy4h0b1b4d0b1b0b1bEb<gEp<gqa0b1b<nwa;k<eAc<dc;k<bmEfAb<cgEhAd<kAb<l;k<bfxAc<haEb<bEcd<hEe<cz5e4b<lEc<o>jca<i>bdo<ts>j<ngh>lf<p5b<bd5d<c5b<o5e<i>pg<dqvEcAbEe<gyuEbu<cEx<uwEf<dEw<cEh<beEe<fsEd<ccn;by<tsEcd<eEby<iEb<oEb<cAe<qEf<bEp<caiEh<bEr<cEh<bEc<bEf<dwEb<geEh<j;k<nsEb<cjEe;k<f9b<syEe;k<bluEh<efEh<f;k<e0c<bgm:b<d:b<bgp>jw<n>d<dp>d<cj>cfLba>ozMb>w<c>x<c>f<b>fMd>cMb>cMd>buNf>coMc>cMl>vMt>dMb>eMd>bMd>hMb>bMb>o<b>b<b>b<b>fMb>e<b>b<c>cz<h>q<o>n<y>bqMc>eMb>vMb>eMc>cj<i>y<g>cxMd>dMf<bm3d5d<e>bjMb>qMd>jMb>lMb>bz<em>m<dh>br<m>e<ce>i<k>g<bo>i<be>de<mMb>cMb>iMi>gMb>jMk>cMd>ceMb>cjMc>bMc>bMb>rMd>bMn>bi<dg>ehMd>bqMj>h<jg;k<g>bni<c>dsyo<c>dsyo<blhmhEb<beEds<eyEjg<";


const $26a7bf62dcb505d1$var$WJ = 22;
const $26a7bf62dcb505d1$var$ZWJ = 31;
const $26a7bf62dcb505d1$var$BK = 34;
const $26a7bf62dcb505d1$var$CR = 36;
const $26a7bf62dcb505d1$var$LF = 37;
const $26a7bf62dcb505d1$var$NL = 38;
const $26a7bf62dcb505d1$var$SP = 41;
const $26a7bf62dcb505d1$var$DI_BRK = 0;
const $26a7bf62dcb505d1$var$IN_BRK = 1;
const $26a7bf62dcb505d1$var$CI_BRK = 2;
const $26a7bf62dcb505d1$var$PAIR_TABLE = [
    "444444444444444444444344444444444",
    // OP
    "044114444110000111004240000000010",
    // CL
    "044114444111110111004240000000010",
    // CP
    "444111444111111111114241111111111",
    // QU
    "144111444111111111114241111111111",
    // GL
    "044111444000000111004240000000010",
    // NS
    "044111444000000111004240000000010",
    // EX
    "044111444001010111004240000000010",
    // SY
    "044111444001110111004240000000010",
    // IS
    "144111444001111111004241111101110",
    // PR
    "144111444001110111004240000000010",
    // PO
    "144111444111110111004240000000010",
    // NU
    "144111444111110111004240000000010",
    // AL
    "144111444111110111004240000000010",
    // HL
    "044111444010000111004240000000010",
    // ID
    "044111444000000111004240000000010",
    // IN
    "044101444001000111004240000000010",
    // HY
    "044101444000000111004240000000010",
    // BA
    "144111444111111111114241111111110",
    // BB
    "044111444000000111044240000000010",
    // B2
    "000000000000000000004000000000000",
    // ZW
    "144111444111110111004240000000010",
    // CM
    "144111444111111111114241111111111",
    // WJ
    "044111444010000111004240001100010",
    // H2
    "044111444010000111004240000100010",
    // H3
    "044111444010000111004241111000010",
    // JL
    "044111444010000111004240001100010",
    // JV
    "044111444010000111004240000100010",
    // JT
    "044111444000000111004240000010010",
    // RI
    "044111444010000111004240000000110",
    // EB
    "044111444010000111004240000000010",
    // EM
    "144111444111110111004240000000010",
    // ZWJ
    "044110444000000000004240000000010"
];
const $26a7bf62dcb505d1$var$rangeStarts = [];
const $26a7bf62dcb505d1$var$rangeClasses = [];
{
    let start = 0;
    let delta = 0;
    for(let i = 0; i < (0, $9bdb35da3b2f257a$export$2b94a4504870571c).length; i++){
        const code = (0, $9bdb35da3b2f257a$export$2b94a4504870571c).charCodeAt(i);
        if (code >= 97) delta = delta * 26 + (code - 97);
        else {
            start += delta;
            $26a7bf62dcb505d1$var$rangeStarts.push(start);
            $26a7bf62dcb505d1$var$rangeClasses.push(code - 48);
            delta = 0;
        }
    }
}const $26a7bf62dcb505d1$export$c2dd6df2c31d6ed9 = (codePoint)=>{
    let low = 0;
    let high = $26a7bf62dcb505d1$var$rangeStarts.length - 1;
    while(low < high){
        const mid = low + high + 1 >> 1;
        if ($26a7bf62dcb505d1$var$rangeStarts[mid] <= codePoint) low = mid;
        else high = mid - 1;
    }
    return $26a7bf62dcb505d1$var$rangeClasses[low];
};
const $26a7bf62dcb505d1$export$37701ea970baee8a = (before, after)=>{
    const codePoints = Array.from(before + after);
    if (codePoints.length !== 2) return false;
    const first = $26a7bf62dcb505d1$export$c2dd6df2c31d6ed9(codePoints[0].codePointAt(0) ?? 0);
    const second = $26a7bf62dcb505d1$export$c2dd6df2c31d6ed9(codePoints[1].codePointAt(0) ?? 0);
    if (first === $26a7bf62dcb505d1$var$BK || first === $26a7bf62dcb505d1$var$LF || first === $26a7bf62dcb505d1$var$NL) return true;
    if (first === $26a7bf62dcb505d1$var$CR) return second !== $26a7bf62dcb505d1$var$LF;
    if (second === $26a7bf62dcb505d1$var$SP || second === $26a7bf62dcb505d1$var$BK || second === $26a7bf62dcb505d1$var$LF || second === $26a7bf62dcb505d1$var$NL || second === $26a7bf62dcb505d1$var$CR) return false;
    if (first === $26a7bf62dcb505d1$var$ZWJ) return false;
    const pair = $26a7bf62dcb505d1$var$PAIR_TABLE[first === $26a7bf62dcb505d1$var$SP ? $26a7bf62dcb505d1$var$WJ : first].charCodeAt(second) - 48;
    if (pair === $26a7bf62dcb505d1$var$DI_BRK) return true;
    return first === $26a7bf62dcb505d1$var$SP && (pair === $26a7bf62dcb505d1$var$IN_BRK || pair === $26a7bf62dcb505d1$var$CI_BRK);
};


const $1febc7c29388a33e$var$insertSeparatorsToText = (currentText, nextText, options)=>{
    const currentSegments = $1febc7c29388a33e$export$1c1c45ab8a52f446(currentText);
    const nextSegments = $1febc7c29388a33e$export$1c1c45ab8a52f446(nextText);
    const formattedText = currentSegments.reduce((accumulatedText, segment, index, array)=>{
        const current = segment;
        const next = array[index + 1] || nextSegments[0];
        return accumulatedText + $1febc7c29388a33e$export$79a303d1c28fc38a(current, next, options);
    }, "");
    return formattedText;
};
let $1febc7c29388a33e$var$segmenter;
const $1febc7c29388a33e$export$1c1c45ab8a52f446 = (src)=>{
    $1febc7c29388a33e$var$segmenter ?? ($1febc7c29388a33e$var$segmenter = new Intl.Segmenter("ja-JP", {
        granularity: "word"
    }));
    return Array.from($1febc7c29388a33e$var$segmenter.segment(src), ({ segment: segment })=>segment);
};
const $1febc7c29388a33e$export$79a303d1c28fc38a = (current, next = "", options)=>{
    if (!next) return current;
    const addThinSpace = options.insertThinSpaces && $1febc7c29388a33e$export$e18992cebb76acb7(current, next);
    const breakable = $1febc7c29388a33e$export$e7fbaa378f7f3cab(current, next);
    if (addThinSpace) {
        const hasMiddleDots = (0, $d393353ec319e16c$export$288a0444d03fbf01).test(current) || (0, $d393353ec319e16c$export$288a0444d03fbf01).test(next);
        const thinSpaceWidth = hasMiddleDots ? `calc(${options.thinSpaceWidth} / 2.0)` : options.thinSpaceWidth ?? "";
        return current + (0, $fb3887f4f09ea4cb$export$9d9a4a3f615f382b)(thinSpaceWidth, breakable);
    }
    if (options.useWordBreak && breakable) return current + (0, $fb3887f4f09ea4cb$export$4e02d859637d5c44)();
    return current;
};
const $1febc7c29388a33e$export$e18992cebb76acb7 = (current, next)=>{
    if ((0, $d393353ec319e16c$export$e847ddd80e1fcdc0).test(current) || (0, $d393353ec319e16c$export$e847ddd80e1fcdc0).test(next)) return false;
    return (0, $cd0af1f91fa0e3d5$export$85bd18d34f99c221).includesPunctuation(current, next) ? (0, $cd0af1f91fa0e3d5$export$85bd18d34f99c221).shouldAddThinSpace(current, next) : (0, $cd0af1f91fa0e3d5$export$af1d3c3d58202762).shouldAddThinSpace(current, next);
};
const $1febc7c29388a33e$export$e7fbaa378f7f3cab = (current, next)=>{
    const currentChar = Array.from(current).at(-1) ?? "";
    const nextChar = Array.from(next)[0] ?? "";
    if (!currentChar || !nextChar) return false;
    if ((0, $d393353ec319e16c$export$e847ddd80e1fcdc0).test(nextChar)) return false;
    if ((0, $26a7bf62dcb505d1$export$37701ea970baee8a)(currentChar, nextChar)) return true;
    return (0, $cd0af1f91fa0e3d5$export$af1d3c3d58202762).canBreakAcrossScripts(currentChar, nextChar);
};
var $1febc7c29388a33e$export$2e2bcd8739ae039 = $1febc7c29388a33e$var$insertSeparatorsToText;






const $c4c13b22a6c647ab$export$12fa93d7db248e32 = (currentNodeValue, nextNodeValue, options)=>{
    if (currentNodeValue === " ") return currentNodeValue;
    return (0, $fb3887f4f09ea4cb$export$6d506fabf9b15659)(currentNodeValue, options.useWordBreak);
};
const $c4c13b22a6c647ab$export$53dc3573e30a04e5 = (currentSegment, nextSegment, options)=>{
    if (currentSegment === " ") return currentSegment;
    if (options.wrapLatin && (0, $cd0af1f91fa0e3d5$export$af1d3c3d58202762).isLatin(currentSegment)) return currentSegment.replace($d393353ec319e16c$export$641194ef37ada0de, (match)=>(0, $fb3887f4f09ea4cb$export$6ef6634d3484b92e)(match));
    if (options.noSpaceBetweenNoBreaks && (0, $cd0af1f91fa0e3d5$export$85bd18d34f99c221).shouldNotBreak(currentSegment)) return currentSegment.replace($d393353ec319e16c$export$198c1e54754651b7, (match)=>(0, $fb3887f4f09ea4cb$export$b9f38fbcc8ce2b6c)(match));
    return currentSegment;
};
const $c4c13b22a6c647ab$export$8e2a4fbfbb66d0 = (currentSegment, nextSegment, options)=>{
    const chars = [
        ...currentSegment
    ];
    const kernedChars = chars.map((currentChar, i)=>{
        const nextChar = chars[i + 1] || [
            ...nextSegment
        ][0] || "";
        const kerningRule = options.kerningRules?.find((rule)=>rule.between[0] === currentChar && rule.between[1] === nextChar);
        if (kerningRule) {
            const kerningValue = typeof kerningRule.value === "number" ? kerningRule.value : parseInt(kerningRule.value, 10);
            const breakable = options.useWordBreak ? false : (0, $1febc7c29388a33e$export$e7fbaa378f7f3cab)(currentChar, nextChar);
            return currentChar + (0, $fb3887f4f09ea4cb$export$cee714c7a7ce6b85)(kerningValue, breakable);
        }
        return currentChar;
    });
    return kernedChars.join("");
};
const $c4c13b22a6c647ab$var$escapeRegExp = (str)=>str.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
const $c4c13b22a6c647ab$var$compiledWrapCharsCache = /* @__PURE__ */ new WeakMap();
const $c4c13b22a6c647ab$var$compileWrapChars = (wrapChars)=>{
    const compiled = [];
    wrapChars.forEach((rule)=>{
        const chars = typeof rule.char === "string" ? [
            rule.char
        ] : rule.char;
        const validChars = chars.filter((ch)=>Array.from(ch).length === 1);
        if (validChars.length === 0) {
            console.error(`Invalid configuration in wrapChars: rule.char does not contain any valid single character.`);
            return;
        }
        let label;
        if (validChars.length === 1) label = rule.label ? rule.label : validChars[0];
        else {
            if (!rule.label) {
                console.error(`Invalid configuration in wrapChars: when grouping multiple characters, a label must be provided.`);
                return;
            }
            label = rule.label;
        }
        const validClassRegex = /^[^"'<>\s]+$/;
        if (!validClassRegex.test(label)) {
            console.error(`Invalid configuration in wrapChars: '${validChars.join(",")}' is used. To be used as a CSS class, the 'label' property must not contain spaces, quotes, '<' or '>'. Skipping this wrapping rule.`);
            return;
        }
        const escapedChars = validChars.map((ch)=>$c4c13b22a6c647ab$var$escapeRegExp(ch)).join("");
        compiled.push({
            regex: new RegExp(`([${escapedChars}]+)`, "gu"),
            // クラス名の例: typesetting-char-あ や typesetting-char-paren
            className: `typesetting-char-${label}`
        });
    });
    return compiled;
};
const $c4c13b22a6c647ab$export$b25366831001a656 = (currentSegment, nextSegment, options)=>{
    if (!options.wrapChars || options.wrapChars.length === 0) return currentSegment;
    let compiled = $c4c13b22a6c647ab$var$compiledWrapCharsCache.get(options.wrapChars);
    if (!compiled) {
        compiled = $c4c13b22a6c647ab$var$compileWrapChars(options.wrapChars);
        $c4c13b22a6c647ab$var$compiledWrapCharsCache.set(options.wrapChars, compiled);
    }
    return compiled.reduce((segment, { regex: regex, className: className })=>segment.replace(regex, (match)=>`<span class="${className}">${match}</span>`), currentSegment);
};



class $dd4fd09297e128cc$var$Typesetter extends (0, $b78c054bfb7eb7dd$export$2e2bcd8739ae039) {
    /**
   * Typesetter のデフォルトの設定を返します。
   */ static getDefaultOptions() {
        return {
            useWordBreak: true,
            wrapLatin: true,
            wrapChars: [],
            noSpaceBetweenNoBreaks: true,
            insertThinSpaces: true,
            thinSpaceWidth: "0.2em",
            kerningRules: []
        };
    }
    constructor(options = {}){
        const isIntlSegmenterSupported = typeof Intl.Segmenter !== "undefined";
        if (!isIntlSegmenterSupported) console.warn("Intl.Segmenter is not supported in this environment. \nTherefore, the options `useWordBreak` and `insertThinSpaces` will be ignored. \nFor more information about Intl.Segmenter, please visit:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Segmenter");
        const transformFunctions = isIntlSegmenterSupported ? [
            (0, $c4c13b22a6c647ab$export$12fa93d7db248e32),
            (0, $1febc7c29388a33e$export$2e2bcd8739ae039),
            (0, $c4c13b22a6c647ab$export$53dc3573e30a04e5),
            (0, $c4c13b22a6c647ab$export$8e2a4fbfbb66d0),
            (0, $c4c13b22a6c647ab$export$b25366831001a656)
        ] : [
            (0, $c4c13b22a6c647ab$export$53dc3573e30a04e5),
            (0, $c4c13b22a6c647ab$export$8e2a4fbfbb66d0),
            (0, $c4c13b22a6c647ab$export$b25366831001a656)
        ];
        const validatedOptions = $dd4fd09297e128cc$var$Typesetter.validateOptions(options);
        super(transformFunctions, validatedOptions);
    }
    /**
   * 与えられたオプションを検証し、修正されたオプションを返します。
   *
   * @param options - 検証するオプション。
   * @return 修正されたオプション。
   */ static validateOptions(options) {
        const merged = {
            ...$dd4fd09297e128cc$var$Typesetter.getDefaultOptions(),
            ...options
        };
        return {
            ...merged,
            wrapChars: (merged.wrapChars ?? []).map((rule)=>({
                    ...rule,
                    char: Array.isArray(rule.char) ? [
                        ...rule.char
                    ] : rule.char
                })),
            kerningRules: (merged.kerningRules ?? []).filter($dd4fd09297e128cc$var$Typesetter.isValidKerningRule).map((rule)=>({
                    ...rule,
                    between: [
                        ...rule.between
                    ]
                })),
            thinSpaceWidth: (0, $fb3887f4f09ea4cb$export$11e646d802d120fb)(merged.thinSpaceWidth)
        };
    }
    /**
   * カーニングルールが適切かどうかを検証します。
   *
   * @param kerningRule - 検証するカーニングルール。
   * @return ルールが有効な場合はtrue、そうでない場合はfalse。
   */ static isValidKerningRule(kerningRule) {
        if (Array.from(kerningRule.between[0]).length !== 1 || Array.from(kerningRule.between[1]).length !== 1) {
            console.warn(`Kerning rule between '${kerningRule.between[0]}' and '${kerningRule.between[1]}' must be single characters.`);
            return false;
        }
        return true;
    }
    /**
   * 与えられたHTML文字列を処理し、指定されたスタイルと区切り文字を適用した結果を返します。
   *
   * @param srcHtml - 処理するHTML文字列。
   * @return 処理後のHTML文字列。
   */ render(srcHtml) {
        if (!srcHtml) return "";
        return this.processHtmlWithFunctions(srcHtml);
    }
    /**
   * 与えられたElementまたはElementの配列に対して、スタイルと区切り文字を適用します。
   * 各要素の innerHTML を処理して置き換えます。
   *
   * @param elements - スタイルを適用するElementまたはHTMLElementの配列。
   */ renderToElements(elements) {
        if (!elements) return;
        if (!Array.isArray(elements)) elements = [
            elements
        ];
        elements.forEach((element)=>{
            const processedHtml = this.render(element.innerHTML);
            element.innerHTML = processedHtml;
        });
    }
    /**
   * 指定されたCSSセレクタに一致するすべての要素にスタイルを適用します。
   * root.querySelectorAllを使用して要素を取得し、それぞれに対してスタイル適用処理を行います。
   *
   * DOMがない環境では何もしません。サーバー側のDOMを使う場合は root を指定してください。
   * @param selector - スタイルを適用する要素を選択するCSSセレクタ。
   * @param root - 検索対象のDocument、Element、DocumentFragment。省略時は実行時のグローバルdocument。
   */ renderToSelector(selector, root = typeof document === "undefined" ? null : document) {
        if (!selector || !root) return;
        const elements = root.querySelectorAll(selector);
        this.renderToElements(Array.from(elements));
    }
}
var $dd4fd09297e128cc$export$2e2bcd8739ae039 = $dd4fd09297e128cc$var$Typesetter;



// HTML要素の取得
const $1e6a16da88d577c6$var$toggleButton = document.getElementById('toggleButton');
const $1e6a16da88d577c6$var$target = document.getElementById('target');
const $1e6a16da88d577c6$var$srcHtml = $1e6a16da88d577c6$var$target.innerHTML;
let $1e6a16da88d577c6$var$renderedHtml = '';
let $1e6a16da88d577c6$var$isTypeset = true;
// オプション関連のDOM要素をキャッシュ
const $1e6a16da88d577c6$var$useWordBreakToggle = document.getElementById('useWordBreakToggle');
const $1e6a16da88d577c6$var$insertThinSpacesToggle = document.getElementById('insertThinSpacesToggle');
const $1e6a16da88d577c6$var$wrapLatinToggle = document.getElementById('wrapLatinToggle');
const $1e6a16da88d577c6$var$noSpaceBetweenNoBreaksToggle = document.getElementById('noSpaceBetweenNoBreaksToggle');
const $1e6a16da88d577c6$var$kerningRulesToggle = document.getElementById('kerningRulesToggle');
const $1e6a16da88d577c6$var$wrapCharsToggle = document.getElementById('wrapCharsToggle');
let $1e6a16da88d577c6$var$options = {
    kerningRules: $1e6a16da88d577c6$var$getKerningRules(),
    wrapChars: $1e6a16da88d577c6$var$getWrapChars()
};
/**
 * 初期化処理を行う関数
 */ function $1e6a16da88d577c6$var$init() {
    $1e6a16da88d577c6$var$toggleButton.addEventListener('click', ()=>{
        $1e6a16da88d577c6$var$toggleTypesetting();
        $1e6a16da88d577c6$var$toggleInputElements($1e6a16da88d577c6$var$toggleButton.checked);
    });
    $1e6a16da88d577c6$var$updateTypesetting();
    $1e6a16da88d577c6$var$setupEmailLink();
    $1e6a16da88d577c6$var$setupOptionEventListeners();
    $1e6a16da88d577c6$var$setupTargetEventListeners();
}
/**
 * メールリンクの設定を行う関数
 */ function $1e6a16da88d577c6$var$setupEmailLink() {
    const emailElement = document.getElementById('email');
    if (emailElement) {
        const emailHtml = emailElement.innerHTML.replace('[-]', '@');
        emailElement.innerHTML = emailHtml;
        const emailText = emailElement.textContent || '';
        emailElement.href = 'mailto:' + emailText;
    }
}
/**
 * インプット要素の有効/無効を切り替える関数
 * @param {boolean} enable - 有効にするかどうか
 */ function $1e6a16da88d577c6$var$toggleInputElements(enable) {
    const inputElements = document.querySelectorAll('#options input[type="checkbox"], #target input[type="checkbox"]');
    inputElements.forEach((element)=>{
        const input = element;
        input.disabled = !enable;
    });
}
/**
 * オプション関連のイベントリスナーを設定する関数
 */ function $1e6a16da88d577c6$var$setupOptionEventListeners() {
    document.querySelectorAll('#options input[type="checkbox"]').forEach((button)=>{
        button.addEventListener('change', $1e6a16da88d577c6$var$handleOptionChange);
    });
}
/**
 * ターゲット要素のイベントリスナーを設定する関数
 */ function $1e6a16da88d577c6$var$setupTargetEventListeners() {
    $1e6a16da88d577c6$var$target.addEventListener('change', (event)=>{
        const target = event.target;
        if (target.matches('input[type="checkbox"]')) $1e6a16da88d577c6$var$handleTargetCheckboxChange(event);
    });
}
/**
 * 組版の切り替えを行う関数
 */ function $1e6a16da88d577c6$var$toggleTypesetting() {
    $1e6a16da88d577c6$var$target.innerHTML = $1e6a16da88d577c6$var$isTypeset ? $1e6a16da88d577c6$var$srcHtml : $1e6a16da88d577c6$var$renderedHtml;
    $1e6a16da88d577c6$var$isTypeset = !$1e6a16da88d577c6$var$isTypeset;
    $1e6a16da88d577c6$var$setupEmailLink();
    if ($1e6a16da88d577c6$var$isTypeset) $1e6a16da88d577c6$var$synchronizeAndSetupTargetCheckboxes();
}
/**
 * オプション変更時の処理を行う関数
 */ function $1e6a16da88d577c6$var$handleOptionChange() {
    $1e6a16da88d577c6$var$updateOptions();
    $1e6a16da88d577c6$var$updateTypesetting();
    $1e6a16da88d577c6$var$synchronizeAndSetupTargetCheckboxes();
    $1e6a16da88d577c6$var$setupEmailLink();
}
/**
 * ターゲットのチェックボックスの状態を同期し、設定を行う関数
 */ function $1e6a16da88d577c6$var$synchronizeAndSetupTargetCheckboxes() {
    document.querySelectorAll('#target input[type="checkbox"]').forEach((checkbox)=>{
        checkbox.addEventListener('change', $1e6a16da88d577c6$var$handleTargetCheckboxChange);
        const checkboxInput = checkbox;
        if (checkboxInput.dataset.id) {
            const optionCheckbox = document.getElementById(checkboxInput.dataset.id);
            if (optionCheckbox && optionCheckbox.checked !== checkboxInput.checked) checkboxInput.checked = optionCheckbox.checked;
        }
    });
}
/**
 * オプションを更新する関数
 */ function $1e6a16da88d577c6$var$updateOptions() {
    $1e6a16da88d577c6$var$options = {
        ...$1e6a16da88d577c6$var$options,
        useWordBreak: $1e6a16da88d577c6$var$useWordBreakToggle.checked,
        insertThinSpaces: $1e6a16da88d577c6$var$insertThinSpacesToggle.checked,
        wrapLatin: $1e6a16da88d577c6$var$wrapLatinToggle.checked,
        noSpaceBetweenNoBreaks: $1e6a16da88d577c6$var$noSpaceBetweenNoBreaksToggle.checked,
        kerningRules: $1e6a16da88d577c6$var$kerningRulesToggle.checked ? $1e6a16da88d577c6$var$getKerningRules() : [],
        wrapChars: $1e6a16da88d577c6$var$wrapCharsToggle.checked ? $1e6a16da88d577c6$var$getWrapChars() : []
    };
}
/**
 * 組版を更新する関数
 */ function $1e6a16da88d577c6$var$updateTypesetting() {
    const typesetter = new (0, $dd4fd09297e128cc$export$2e2bcd8739ae039)($1e6a16da88d577c6$var$options);
    $1e6a16da88d577c6$var$renderedHtml = typesetter.render($1e6a16da88d577c6$var$srcHtml);
    if ($1e6a16da88d577c6$var$isTypeset) $1e6a16da88d577c6$var$target.innerHTML = $1e6a16da88d577c6$var$renderedHtml;
}
/**
 * ターゲットのチェックボックス変更時の処理を行う関数
 * @param {Event} event - 発生したイベント
 */ function $1e6a16da88d577c6$var$handleTargetCheckboxChange(event) {
    const checkbox = event.target;
    const optionCheckboxId = checkbox.dataset.id;
    if (optionCheckboxId) {
        const optionCheckbox = document.getElementById(optionCheckboxId);
        if (optionCheckbox) {
            optionCheckbox.checked = checkbox.checked;
            $1e6a16da88d577c6$var$handleOptionChange();
        }
    }
}
/**
 * カーニングルールを取得する関数
 * @returns {KerningRule[]} カーニングルールの配列
 */ function $1e6a16da88d577c6$var$getKerningRules() {
    return [
        {
            between: [
                "\u7F8E",
                "\u3057"
            ],
            value: 60
        },
        {
            between: [
                "\u30B9",
                "\u30C8"
            ],
            value: 120
        },
        {
            between: [
                "\u30A4",
                "\u30D6"
            ],
            value: 20
        },
        {
            between: [
                "\u30D6",
                "\u30E9"
            ],
            value: -30
        },
        {
            between: [
                "\u30E9",
                "\u30EA"
            ],
            value: 30
        },
        {
            between: [
                "\u3066",
                "\u3001"
            ],
            value: -60
        },
        {
            between: [
                "\u3059",
                "\u3002"
            ],
            value: -120
        },
        {
            between: [
                "\u3088",
                "\u3046"
            ],
            value: 60
        },
        {
            between: [
                "\u3046",
                "\u306A"
            ],
            value: 40
        },
        {
            between: [
                "\u3055",
                "\u308C"
            ],
            value: 20
        },
        {
            between: [
                "\u308C",
                "\u305F"
            ],
            value: -60
        },
        {
            between: [
                "\u4F9B",
                "\u3057"
            ],
            value: 40
        },
        {
            between: [
                "\u3057",
                "\u307E"
            ],
            value: 70
        }
    ];
}
/**
 * 特例文字の設定を取得する関数
 * @returns {wrapCharRule[]} 特例文字の設定の配列
 */ function $1e6a16da88d577c6$var$getWrapChars() {
    return [
        {
            char: "\u2197",
            label: 'arrow'
        },
        {
            char: [
                '(',
                ')'
            ],
            label: 'parenthesis'
        }
    ];
}
// 初期化処理
document.addEventListener('DOMContentLoaded', $1e6a16da88d577c6$var$init);


//# sourceMappingURL=demo.d6f40f40.js.map
